export default {
  GET_GOODS_STOCK_LIST: Symbol('GET_GOODS_STOCK_LIST'),
  GET_GOODS_STORAGE_SUMMARY: Symbol('GET_GOODS_STORAGE_SUMMARY'),
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  SET_SEARCH_VALUE: Symbol('SET_SEARCH_VALUE'),
  GET_STANDARD_STOCK_LIST: Symbol('GET_STANDARD_STOCK_LIST'),
  GET_STANDARD_STOCK_ROOM_LIST: Symbol('GET_STANDARD_STOCK_ROOM_LIST'),
  GET_ROOMS_LIST: Symbol('GET_ROOMS_LIST'),
};
